import React from 'react'

import { Popover } from 'ui/components/Popover'

type PopupProps = React.ComponentPropsWithoutRef<typeof Popover>

export const Popup: React.FC<PopupProps> = (props) => {
    return <Popover {...props} />
}
